<template>
    <section id="home" class="grid-section">
        <transition appear name="icon">
            <img src="@/assets/svg/portrait.svg" class="section-icon" id="profile-icon">
        </transition>
        <div id="profile-teaser">
            <transition appear name="appear-left">
                <div class="transition-wrapper">
                    <h2>Hi. my name is <strong>Tobi Hoffmann.</strong> I’m a UX designer / art director based in Berlin.
                    </h2>
                    <div class="wrapper-go-to">
                        <div class="btn"><a href="#" v-scroll-to="'#profile'">Profile</a>
                            <div></div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <transition appear name="icon2">
            <img src="@/assets/svg/circle.svg" class="section-icon" id="projects-icon">
        </transition>

        <div id="projects-teaser">
            <transition appear name="appear-right">
                <div class="transition-wrapper">
                    <h3>Feel free to take a look at some of my <strong>work.</strong></h3>
                    <div class="btn"><a href="#" v-scroll-to="'#projects'">Projects</a>
                        <div></div>
                    </div>
                </div>
            </transition>
        </div>

        <transition appear name="icon3">
            <img src="@/assets/svg/text.svg" class="section-icon" id="contact-icon">
        </transition>

        <div id="contact-teaser">
            <transition appear name="appear-right2">
                <div class="transition-wrapper">
                    <h3>Are you interested in working <strong>together?</strong></h3>
                    <div class="btn"><a href="#" v-scroll-to="'#contact'">Contact</a>
                        <div></div>
                    </div>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style lang="css" scoped>

    #home {
        flex-wrap: wrap;
        justify-content: center;
    }

    .section-icon {
        margin-top: -2rem;
        margin-left: -2rem;
    }

    #profile-icon {
        grid-column: 2 / 4;
        grid-row: 2 / 4;
    }

    #profile-teaser {
        grid-column: 2 / 4;
        grid-row: 2 / 4;
        overflow: hidden;
    }

    #projects-icon {
        grid-column: 3 / 4;
        grid-row: 5 / 6;
    }

    #projects-teaser {
        grid-column: 3 / 4;
        grid-row: 5 / 6;
        overflow: hidden;
    }

    #contact-icon {
        grid-column: 5 / 6;
        grid-row: 5 / 6;
    }

    #contact-teaser {
        grid-column: 5 / 6;
        grid-row: 5 / 6;
        overflow: hidden;
    }

    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

        .section-icon {
            display: none;
        }

        #projects-teaser {
            margin-top: 7vh;
        }

        #contact-teaser {
            margin-top: 4vh;
        }
    }

</style>
